import { useStore as useContact } from "./contact";
import { useStore as useAccount } from "./account";
import { useStore as useBlogs } from "./blogs";
import { useStore as useProducts } from "./products";
import { useStore as useLocator } from "./locator";
import { useStore as useFilter } from "./filter";
import { useStore as useSubscribe } from "./subscribe";
import { useStore as useStoreCart } from "./cart";
import { useStore as useCheckout } from "./checkout";
import { useStore as useReviews } from "./reviews";
import { useStore as useDirections } from "./directions";
import { useStore as useNavbar } from "./navbar";
import { useStore as useWarranty } from "./warranty";
import { useStore as useColours } from "./filter/colours";
import { useStore as useNewFilter } from "./filter/new-filter";
import { useStore as useSizes } from "./filter/sizes";
import { useStore as useWheelSizes } from "./filter/wheel-sizes";
import { useStore as useBrakeTypesStore } from "./filter/brake-type";
import { useStore as useSearchStore } from "./search/index";
import { useStore as useLogin } from "./login/index";
import { useStore as useProductCategory } from "./filter/product-category";
import { useStore as useWishlist } from "./wishlist";
import { useStore as useDashboard } from "./dashboard/index";
import { useStore as useUrlState } from "./urlState";


const { subscribe } = useSubscribe();
const { checkNav } = useNavbar();
export {
  useContact,
  subscribe,
  checkNav,
  useAccount,
  useBlogs,
  useProducts,
  useLocator,
  useFilter,
  useSubscribe,
  useReviews,
  useDirections,
  useStoreCart,
  useCheckout,
  useWarranty,
  useColours,
  useSizes,
  useWheelSizes,
  useBrakeTypesStore,
  useProductCategory,
  useNewFilter,
  useWishlist,
  useSearchStore,
  useUrlState,
  useLogin,
  useDashboard
};
